import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ThemePipe } from '../../../../core/pipes/theme.pipe';
import { CurrencyIconComponent } from '../../../../ui/currency/currency-icon/currency-icon.component';

// The prize line every tier card shows: the primary amount with its currency icon, the
// secondary amount in parentheses on match-and-user skins, and a shadow copy stacked under
// each piece on skins that ask for one. The paid, free and practice cards all render this
// so the line cannot drift between them; each card owns its token pairs, this owns the
// markup and the skin flags that shape it.
@Component({
  selector: 'app-wager-prize',
  templateUrl: './wager-prize.component.html',
  styleUrls: ['./wager-prize.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgTemplateOutlet, ThemePipe, CurrencyIconComponent],
})
export class WagerPrizeComponent {
  readonly primary = input.required<CurrencyAmountDisplay>();
  // The user-currency amount; only shown on match-and-user skins. Null for cards whose
  // prize has no second currency (practice).
  readonly secondary = input<CurrencyAmountDisplay | null>(null);
  readonly textStyles = input.required<[string, string][]>();
  readonly shadowStyles = input<[string, string][]>([]);

  private readonly themeService = inject(ThemeService);

  readonly hasShadow = computed(() => this.themeService.hasWagerCardPrizeShadow());
  readonly shownSecondary = computed(() =>
    this.themeService.hasSecondaryCurrency ? this.secondary() : null,
  );
}
